import * as jQuery from 'jquery';
import * as moment from 'moment';
import { forkJoin, Observable } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { AfterViewInit, Component, OnDestroy, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { Configuration } from '../../../analytics-core/interfaces/configuration.interface';
import { EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';

@Component({
	selector: 'app-breadcrumb',
	styleUrls: ['../styles/breadcrumb.component.css'],
	templateUrl: '../views/breadcrumb.component.html'
})
export class BreadcrumbComponent implements OnInit, AfterViewInit, OnDestroy {
	public configuration: Configuration;
	public content: string;

	public isMenuActive = true;
	public showCalendar: boolean = true;
	public advertisersCount: any;
	public campaignsCount: any;
	public toggleSubscription;
	public advSubscription;
	public cmpSubscription;
	public daterangeSubscription;
	public daterange: any = {
		endDate: moment().format('MM/DD/YYYY'),
		label: '',
		startDate: moment().subtract(1, 'months').format('MM/DD/YYYY')
	};
	constructor(private http: HttpClient, private analyticsDataModel: AnalyticsDataModel) {
		this.toggleSubscription = EmitterService.get('TOGGLE_CALENDAR').subscribe((resp: any) => {
			this.showCalendar = !resp;
		});
		this.advSubscription = EmitterService.get(EVENT_EMITTERS.ADVERTISERS).subscribe((resp: any) => {
			this.advertisersCount = resp.length;
		});
		this.cmpSubscription = EmitterService.get(EVENT_EMITTERS.CAMPAIGNS).subscribe((resp: any) => {
			this.campaignsCount = resp.length;
		});
		this.daterangeSubscription = EmitterService.get(EVENT_EMITTERS.DATE_RANGE).subscribe((resp: any) => {
			this.daterange.startDate = moment(resp.startDate).format('MM/DD/YYYY');
			this.daterange.endDate = moment(resp.endDate).format('MM/DD/YYYY');
		});
	}

	ngOnInit(): void {
		this.configuration = this.analyticsDataModel.config;
		this.advertisersCount = 0;
		this.campaignsCount = 0;
	}

	ngAfterViewInit(): void {
		const url = `assets/partner-assets/${this.getDirectoryName()}/views/breadcrumb.html`;
		const breadcrumb = this.http.get(url, { responseType: 'text' });
		forkJoin([breadcrumb]).subscribe(
			(responses: any[]) => {
				let html = '';
				for (const resp of responses) {
					html += resp;
				}
				this.content = html;
			},
			(err) => console.error(err)
		);
	}

	getDirectoryName(): string {
		if (this.configuration.useDefaultHtmls) {
			return `default-${this.configuration.version.toLowerCase()}`;
		}
		return this.configuration.partner.directoryName;
	}

	breadcrumbElemClicked(event: any): void {
		// TODO: Need to remove the dependency on the component to fire datepicker event on calendar container click
		if (jQuery(event.target).hasClass('dateTarget')) {
			// TODO: Need to call blur or focusout event
			jQuery('.dateTarget').find('.dp-popup').parent().css('visibility', 'hidden');
			jQuery(event.target.parentElement).find('input').focus();
		}
	}
	showCalendarComp(): void {
		this.showCalendar = !this.showCalendar;
	}
	ngOnDestroy(): void {
		if (this.advSubscription) {
			this.advSubscription.unsubscribe();
		}
		if (this.cmpSubscription) {
			this.cmpSubscription.unsubscribe();
		}
		if (this.daterangeSubscription) {
			this.daterangeSubscription.unsubscribe();
		}
	}
}
